import { Angulartics2GoogleAnalytics } from "angulartics2/ga";

declare var trackJs;

export function configureTrackJs(
  ssoUser: any,
  ag2analytics: Angulartics2GoogleAnalytics
) {
  try {
    trackJs.configure({
      userId: `${ssoUser.userName} (#${ssoUser.userId}), Account ${ssoUser.account} (#${ssoUser.accountId})`,
    });

    ag2analytics.setUserProperties({
      userId: ssoUser.userId,
      name: `${ssoUser.firstName} ${ssoUser.lastName}`,
      email: ssoUser.userName,
    });

    ag2analytics.eventTrack("Login", {
      success: true,
      reason: "", // no message for success login
      username: ssoUser.userName,
    });
  } catch (_) {}
}
